(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-images"] && !Shopify.designMode) return;
  try {
    /* ----------------------------- Image Switching ---------------------------- */
  document.querySelectorAll('.product-images__thumbnail').forEach((thumbnail) => {
    thumbnail.addEventListener('click', (e) => {
      if (thumbnail.classList.contains('active')) {
        return;
      }
      document.querySelector('.product-images__thumbnail.active')?.classList.remove('active');
      document.querySelector('.product-images__image.active')?.classList.remove('active');
      document
        .querySelector(`.product-images__image[data-image-id="${thumbnail.dataset.imageId}"]`)
        ?.classList.add('active');
      thumbnail.classList.add('active');
    });
  });

  /* -------------------------------- Lightbox -------------------------------- */
  document.querySelectorAll('.product-images__image').forEach((image) => {
    image.addEventListener('click', (e) => {
      if (document.querySelector('.product-images__lightbox')) return;

      const imgUrl = image.querySelector('img')?.src;
      if (!imgUrl) {
        return;
      }

      const previousFocus = document.activeElement;

      const lightbox = Object.assign(document.createElement('div'), {
        className: 'product-images__lightbox',
        innerHTML: `<img src="${imgUrl}">`,
      });
      lightbox.setAttribute('role', 'dialog');
      lightbox.setAttribute('aria-modal', 'true');

      const closeBtn = Object.assign(document.createElement('button'), {
        className: 'product-images__lightbox__close',
        innerHTML: `&#x2716;`,
      });
      closeBtn.setAttribute('aria-label', 'Close');
      lightbox.prepend(closeBtn);

      const lightboxBackdrop = Object.assign(document.createElement('div'), {
        className: 'product-images__lightbox-backdrop',
      });

      function closeLightbox() {
        lightbox.remove();
        lightboxBackdrop.remove();
        previousFocus?.focus();
      }

      closeBtn.addEventListener('click', closeLightbox);
      lightboxBackdrop.addEventListener('click', closeLightbox);
      document.addEventListener(
        'keydown',
        (e) => {
          if (e.key === 'Escape') {
            closeLightbox();
          }
        },
        { once: true }
      );

      lightbox.addEventListener('click', (e) => {
        lightbox.classList.toggle('zoomed');
      });

      document.body.append(lightbox, lightboxBackdrop);
      closeBtn.focus();
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["qty-box"] && !Shopify.designMode) return;
  try {
    // Init qty boxes
  document.querySelectorAll('.input-quantity__wrapper').forEach((el) => QtyBox.register(el));
  } catch(e) { console.error(e); }
})();

})();
